import React from "react";
import {UserBonusStatus, UserBonusView} from "../http/protocol";
import {getContainer} from "../ioc/IOCSetup";
import "./BonusPage.scss";
import Translator from "../Translator";
import {formatDate} from "../utils/date";
import {t} from "../i18n";
import {isMobile} from "react-device-detect";

interface Props {
    activeCurrency:string
}
export class BonusHistory extends React.Component<Props, { bonuses : UserBonusView[], loading : boolean} > {
    constructor(props : Props) {
        super(props);
        this.state = { bonuses : [], loading : true};

    }

    componentDidMount() {
        console.log("isMobile?: ", isMobile)
        getContainer().getUserBonusService().listBonuses().then(r => {

            this.setState({ bonuses : r.items ? r.items : [], loading : false});
        })
    }

    render() {
        return (
            <div>
                <div className={"bonus-history-titles"}>
                    <div className={"left"}>
                        <div>{t("bonus.name-date")}</div>
                    </div>
                    {isMobile ? (
                        <div className={"right"}>
                            <div className={"amount"}>
                                {t("bonus.amount")}/{t("bonus.progress")}
                            </div>
                            <div className={"status"}>
                                {t("bonus.status-label")}
                            </div>
                        </div>
                    ) : (
                        <div className={"right"}>
                            <div className={"amount"}>
                                {t("bonus.amount")}
                            </div>
                            <div className={"current-progress"}>
                                {t("bonus.progress")}
                            </div>
                            <div className={"status"}>
                                {t("bonus.status-label")}
                            </div>
                        </div>
                    )}

                </div>
                {this.state.bonuses.map( b => {
                    if(b.currency === this.props.activeCurrency) {
                        return(
                            <div className={"bonus-history-row"} key={b.id}>
                                <div className={"left"}>
                                    <div className={"name"}>
                                        {b.bonusConfig && <Translator defaultTranslation={b.bonusConfig.name} translations={b.bonusConfig.translations ? b.bonusConfig.translations.map(t=>({lng : t.language, value : t.name})) as any : []} />}
                                    </div>
                                    <div className={"timestamp"}>
                                        {formatDate(b.timestamp)}
                                    </div>
                                </div>
                                {isMobile ? (
                                    <div className={"right"}>
                                        <>
                                            <div className={"amount"}>{b.totalBonusAmount} {b.currency}</div>
                                            <div className="current-progress">
                                                {b.status == UserBonusStatus.RUNNING ? b.currentTurnover + "/" + b.turnoverRequirement : "-"}
                                            </div>
                                        </>
                                        <div className={"status"}>{t("bonus.status."+b.status)}</div>
                                    </div>
                                ) : (
                                    <div className={"right"}>
                                        <div className={"amount"}>{b.totalBonusAmount} {b.currency}</div>
                                        <div className="current-progress">
                                            {b.status == UserBonusStatus.RUNNING ? b.currentTurnover + "/" + b.turnoverRequirement : "-"}
                                        </div>
                                        <div className={"status"}>{t("bonus.status."+b.status)}</div>
                                    </div>
                                )}
                            </div>
                        )
                    }
                })}
            </div>
        );
    }
}
